export type FieldType = 'NUMBER' | 'TEXT' | 'SELECT' | 'BOOLEAN' | 'CLOCK';
export type ChartType = 'LINE' | 'BAR' | 'DONUT' | 'STAT';
export type Aggregation = 'LATEST' | 'SUM' | 'AVG' | 'COUNT' | 'PERCENT_TRUE';

export const CHART_TYPES_BY_FIELD: Record<FieldType, ChartType[]> = {
  NUMBER: ['LINE', 'BAR', 'STAT'],
  SELECT: ['DONUT', 'BAR', 'STAT'],
  BOOLEAN: ['LINE', 'DONUT', 'STAT'],
  TEXT: ['STAT'],
  CLOCK: ['LINE', 'BAR', 'STAT'],
};

export const AGGREGATIONS_BY_FIELD: Record<FieldType, Aggregation[]> = {
  NUMBER: ['LATEST', 'SUM', 'AVG', 'COUNT'],
  SELECT: ['LATEST', 'COUNT'],
  BOOLEAN: ['LATEST', 'PERCENT_TRUE', 'COUNT'],
  TEXT: ['LATEST'],
  CLOCK: ['LATEST'],
};

export const defaultChartTypeFor = (fieldType: FieldType): ChartType =>
  CHART_TYPES_BY_FIELD[fieldType][0];

export const defaultAggregationFor = (fieldType: FieldType): Aggregation =>
  AGGREGATIONS_BY_FIELD[fieldType][0];

export const chartTypeOptions = (fieldType: FieldType) =>
  CHART_TYPES_BY_FIELD[fieldType].map((t) => ({ value: t, label: t }));

export const aggregationOptions = (fieldType: FieldType) =>
  AGGREGATIONS_BY_FIELD[fieldType].map((a) => ({ value: a, label: a }));
